import * as yup from 'yup';

const phoneRegex =
	/^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/;

export const phoneNumberValidation = yup
	.string()
	.nullable()
	.transform((value) => (value === '' ? null : value))
	.matches(phoneRegex, {
		message: 'Please enter a valid phone number',
		excludeEmptyString: true,
	})
	.min(6)
	.max(15);
